import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-more-events-info-btn',
    templateUrl: './more-events-info-btn.component.html',
    styleUrl: './more-events-info-btn.component.scss',
    standalone: false
})
export class MoreEventsInfoBtnComponent {
  @Input() public text: string;
  @Input() public tooltipText: string;
}
